// Página "Conversões" da Meta (Conversions API, #317): helpers puros, sem React e sem rede.
// A regra de verdade (hash, deduplicação, permissão) é do backend; aqui só montamos a tela.

export const LOG_STATUS = {
  sent: { label: 'Enviado', tone: 'green' },
  failed: { label: 'Falhou', tone: 'red' },
  skipped: { label: 'Pulado', tone: 'amber' },
}

export const SOURCE_LABELS = { rule: 'Regra da etapa', automation: 'Automação', retry: 'Reenvio' }

export const LOG_FILTERS = [
  { value: '', label: 'Todos' },
  { value: 'sent', label: 'Enviados' },
  { value: 'failed', label: 'Falhas' },
  { value: 'skipped', label: 'Pulados' },
]

// event_map do backend -> { [stage_id]: 'Purchase' }.
export const mapFromSettings = (eventMap = []) =>
  Object.fromEntries(eventMap.map((row) => [row.stage_id, row.event_name]))

// Sem mapa salvo, sugere "etapa de ganho -> Compra" (o usuário pode trocar ou limpar).
export function initialMap(eventMap, stages) {
  if (eventMap?.length) return mapFromSettings(eventMap)
  return Object.fromEntries(stages.filter((s) => s.is_ganho).map((s) => [s.id, 'Purchase']))
}

// Etapas agrupadas por funil, na ordem recebida.
export function groupStages(stages = []) {
  const groups = new Map()
  for (const stage of stages) {
    if (!groups.has(stage.pipeline_id)) groups.set(stage.pipeline_id, { id: stage.pipeline_id, name: stage.pipeline_nome, stages: [] })
    groups.get(stage.pipeline_id).stages.push(stage)
  }
  return [...groups.values()]
}

export const mappedCount = (map) => Object.values(map).filter(Boolean).length

export function validateForm(form) {
  const errors = {}
  if (!form.accountId) errors.accountId = 'Escolha a conta de anúncios.'
  if (!/^\d{1,32}$/.test((form.datasetId || '').trim())) errors.datasetId = 'Escolha o dataset (pixel) ou informe o ID numérico.'
  if (form.enabled && mappedCount(form.map) === 0) errors.map = 'Mapeie ao menos uma etapa para ligar o envio.'
  return errors
}

export function buildSavePayload(form, clientId) {
  return {
    client_id: clientId,
    meta_account_id: String(form.accountId),
    dataset_id: form.datasetId.trim(),
    enabled: Boolean(form.enabled),
    event_map: Object.entries(form.map)
      .filter(([, event]) => event)
      .map(([stage_id, event_name]) => ({ stage_id, event_name })),
  }
}

// Mudou algo em relação ao que está salvo? Habilita o botão Salvar.
export function hasChanges(form, saved) {
  if (!saved) return true
  const same = (a, b) => JSON.stringify(Object.entries(a).filter(([, v]) => v).sort()) === JSON.stringify(Object.entries(b).filter(([, v]) => v).sort())
  return form.accountId !== saved.accountId || form.datasetId.trim() !== saved.datasetId
    || Boolean(form.enabled) !== Boolean(saved.enabled) || !same(form.map, saved.map)
}

// Identificadores que foram à Meta ("e-mail, telefone"), sem nunca mostrar o dado em si.
export const identifiersText = (summary) =>
  (summary?.identifiers?.length ? summary.identifiers.join(', ') : '—')

export const canRetry = (row) => row.status === 'failed' || row.status === 'skipped'

export function formatWhen(iso) {
  return iso ? new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : '—'
}

export const formatValue = (summary) =>
  summary?.value
    ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: summary.currency || 'BRL' }).format(summary.value)
    : '—'
